import { Component } from '@angular/core';

@Component({
  selector: 'app-workflow',
  templateUrl: './workflow.component.html',
  styleUrls: [],
})
export class WorkflowComponent {}
